import { FormControlLabel, Checkbox, Paper } from "@mui/material";
import { Flex } from "~/components/Flex";
import { SecurityPipelineGithubPageTabHeading } from "../SecurityPipelineGithubPageTabHeading/SecurityPipelineGithubPageTabHeading";
import { Controller, useFormContext } from "react-hook-form";
import { SecurityPipelineGithubAutomateFormValues } from "./types";

interface SecurityPipelineGithubAutomateRegressionProps {
  onAutoCreateWorkflowsChange: (autoCreateWorkflows: boolean) => void;
  isLoading: boolean;
}

export const SecurityPipelineGithubAutomateRegression = ({
  onAutoCreateWorkflowsChange,
  isLoading,
}: SecurityPipelineGithubAutomateRegressionProps) => {
  const { control } =
    useFormContext<SecurityPipelineGithubAutomateFormValues>();
  return (
    <Paper sx={{ p: 3 }}>
      <Flex flexDirection="column" gap={3}>
        <SecurityPipelineGithubPageTabHeading
          title="Regression handling"
          description="Automatically generate a pull request when a resolved finding appears."
        />
        <Controller
          control={control}
          name="autoCreateWorkflows"
          render={({ field }) => (
            <FormControlLabel
              control={
                <Checkbox
                  {...field}
                  checked={field.value}
                  disabled={isLoading}
                  onChange={() => {
                    field.onChange(!field.value);
                    onAutoCreateWorkflowsChange(!field.value);
                  }}
                />
              }
              label="Enable automatic regression fixes"
            />
          )}
        />
      </Flex>
    </Paper>
  );
};
